import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { Header } from "@/components/Header";
import { StatoUtenzeStrip } from "@/components/StatoUtenzeStrip";
import { DevLoginPanel } from "@/components/dev/DevLoginPanel";
import { useAuth } from "@/auth/useAuth";
import { NewsUrgentiModal } from "@/components/news/NewsUrgentiModal";
import { CallDock } from "@/support/CallDock";
import { IncomingCallModal } from "@/support/IncomingCallModal";
import { SupportProvider } from "@/support/SupportContext";
import { InstallPrompt } from "@/pwa/InstallPrompt";

export function MainLayout() {
  const { hasRole } = useAuth();
  const isStaff = hasRole("affiliato") || hasRole("operatore");
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <SupportProvider>
      <div className="min-h-screen bg-surface overflow-x-clip">
        <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
        <div className="md:ml-[220px]">
          <Header onMenuClick={() => setMobileOpen(true)} />
          {isStaff && <StatoUtenzeStrip />}
          <main className="p-4 md:p-6 pb-24 md:pb-6">
            <Outlet />
          </main>
        </div>
        <DevLoginPanel />
        <NewsUrgentiModal />
        <IncomingCallModal />
        <CallDock />
        <InstallPrompt />
      </div>
    </SupportProvider>
  );
}
